import { Request } from '@mam/main/ApiClient';
import { DistributionType } from '../domain';

export enum ERPGrowthRevenueError {}

export const getHumanReadableErrorCode = (codes: Set<string>): string | null => {
	return null;
};

export class ERPInputPriceRequest implements Request<Record<never, never>, Record<never, never>> {
	public readonly knownErrorCodes = Object.values(ERPGrowthRevenueError);
	public readonly path: string;
	public readonly method = 'put';
	public readonly body: BodyInit | null = null;

	public constructor(
		userId: string,
		virtualPackId: string,
		sessionId: string,
		userDefinedPrices: {
			country: string;
			price?: string;
			currency: string;
			selectedPrice: string | null;
			isUserDefined: boolean;
			manuallyChanged: boolean;
			distributionType: DistributionType;
			isEdited: boolean;
		}[]
	) {
		this.path = `users/${userId}/erp/packages/${virtualPackId}/sessions/${sessionId}/prices`;
		this.body = JSON.stringify({
			changedPrices: userDefinedPrices
				.filter(({ isEdited }) => isEdited)
				.map(({ country, distributionType, isUserDefined, selectedPrice, price, currency }) => {
					return {
						country,
						[isUserDefined ? 'userPrice' : 'sourcePriceId']: isUserDefined
							? {
									price: {
										value: Number(price),
										currency,
									},
									distributionType: distributionType ?? 'retail',
							  }
							: selectedPrice,
					};
				}),
		});
	}

	decode(response: Record<never, never>) {
		return response;
	}
}
